import type { ReadingBlock, ReadingSection, Exercise } from '../../types.ts';
export { section, number, choice, source, exercise } from '../helpers.ts';
export const paragraph = (text: string): ReadingBlock => ({ kind: 'paragraph', text });
export const equation = (
  label: string,
  left: string,
  right: string,
  reason: string,
): ReadingBlock => ({ kind: 'equation', label, lines: [{ left, right, reason }] });
export const table = (caption: string, headers: string[], rows: string[][]): ReadingBlock => ({
  kind: 'table',
  caption,
  headers,
  rows,
});
export const example = (title: string, ...blocks: (string | ReadingBlock)[]): ReadingBlock => ({
  kind: 'example',
  title,
  blocks: blocks.map((b) => (typeof b === 'string' ? paragraph(b) : b)),
});
export function quantitative(
  id: string,
  category: 'reason' | 'math',
  title: string,
  sections: ReadingSection[],
  question: Exercise['questions'][number],
): Exercise {
  return {
    id,
    category,
    title,
    topic: sections[0].title,
    difficulty: 'Challenging',
    questions: [question],
    reading: {
      title: sections[0].title,
      sections,
      sources: [],
      authorship: 'Original teaching and questions prepared with AI assistance.',
    },
  };
}
